"use client";

import React from "react";
import { TaskNotesTimeline } from "@/components/entity-notes";
import { TaskModalCommentFooter } from "@/features/tasks/components/TaskModalCommentFooter";

interface TaskNotesDisplayProps {
  taskId: string;
  showAddButton?: boolean;
  maxHeight?: string;
  compact?: boolean;
  onRefresh?: () => void;
}

export function TaskNotesDisplay({
  taskId,
  showAddButton = true,
  maxHeight = "400px",
  compact = false,
  onRefresh,
}: TaskNotesDisplayProps) {
  void showAddButton;
  void onRefresh;

  return (
    <div className="space-y-4">
      <TaskNotesTimeline taskId={taskId} maxHeight={compact ? "200px" : maxHeight} />
      <TaskModalCommentFooter taskId={taskId} />
    </div>
  );
}
